import { render, staticRenderFns } from "./Deployments.vue?vue&type=template&id=a1f95a7c&scoped=true"
import script from "./Deployments.vue?vue&type=script&lang=js"
export * from "./Deployments.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a1f95a7c",
  null
  
)

export default component.exports